const SERVICE_AREAS = [
    { name: 'Within 1 hour of business location', value: 'within_1_hour' },
    { name: 'Countrywide', value: 'countrywide' },
    { name: 'Statewide', value: 'statewide' },
    { name: 'Nationwide', value: 'nationwide' },
    { name: 'No Preference', value: 'no_preference' }
];

export default SERVICE_AREAS;
